<template>
  <div>
    <h1>Deshabilitar Administrador </h1>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <label>Evidencia (adjuntar archivo .jpg, .png, .pdf)</label>
              <b-form-file
                v-model="$v.admin.file.$model"
                ref="file"
                :state="fileState"
                placeholder="Evidencia"
                browse-text="Adjuntar"
                drop-placeholder="Drop file here..."
                @change="onFileSelected"
                required
                accept="application/pdf,image/x-png,image/gif,image/jpeg"
                ></b-form-file>
            </div>
            <div class="col-md-6">
              <a-form-item label="Motivo de baja">
                <a-input ref="name" placeholder="Motivo de baja" v-model="$v.admin.reason.$model" />
                <small class="text-danger" v-if="!$v.admin.reason.required">Campo requerido. No puede estar vacío.</small><br>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button ref="button" type="submit" class="btn btn-light px-5" :disabled="$v.$invalid">
                  Deshabilitar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { uploadFileS3 } from '../../../s3/s3Up.js'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const CREATE_USER_BAN = gql`
  mutation createUserBan($reason: String, $fileUrl: String, $disabledBy: String, $userId: Int){
    createUserBan(userBanReq: { reason: $reason fileUrl: $fileUrl disabledBy: $disabledBy userId: $userId }){
      id
      reason
    }
  }
`
const MUTATION_DISABLE_USER = gql`
  mutation disableUser($id: Int!, $username: String){
    disableUser(id: $id, username: $username){
      id
      name
      email
      userName
      active
      role{
        id
        name
      }
    }
  }`
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      admin: {
        file: null,
        reason: '',
      },
      fileState: null,
      disabledBy: this.$store.state.user.email,
      userId: this.$route.params.id,
    }
  },
  methods: {
    onFileSelected(event) {
      this.admin.file = event.target.files[0]
    },
    async handleSubmit() {
      const file = []
      file.fileExtension = this.admin.file.name.split('.').pop()
      file.fileUploaded = this.admin.file
      file.fileUploaded = this.admin.file
      const uploadedFile = await uploadFileS3(file)

      this.$apollo.mutate({
        mutation: CREATE_USER_BAN,
        context: headers(),
        variables: {
          reason: this.admin.reason,
          disabledBy: this.disabledBy,
          userId: parseInt(this.userId),
          fileUrl: uploadedFile.Location,
        },
      })
        .then(data => {
          this.$apollo.mutate({
            mutation: MUTATION_DISABLE_USER,
            context: headers(),
            variables: {
              id: parseInt(this.userId),
              username: this.disabledBy,
            },
          })
            .then(data => {
              console.log(data)
              this.$router.push('/admin/administradores')
            })
            .catch(error => {
              console.log(error)
            })
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
  created() {
    console.log(this.$route.params)
  },
  validations: {
    admin: {
      file: { required },
      reason: { required },
    },
  },
}
</script>
